module.exports = __webpack_public_path__ + "img/ask_1.d9dc2faa.jpg";